import serverCode from '../../serverCode'

const defaultState = () => ({
  items: [],
  length: 0,
})

const state = defaultState()

const mutations = {
  setItems(state, payload) {
    state.length = payload.length
    state.items = state.items.concat(payload)
  },
  init(state) {
    Object.assign(state, defaultState())
  },
  resetItems(state) {
    Object.assign(state, defaultState())
  },
}

const actions = {
  async getItems({ commit, rootState }) {
    try {
      const { succeed, questionnaires } = await serverCode(
        'getQuestionnaires',
        {},
        rootState.locale
      )
      if (!succeed) {
        throw new Error()
      } else {
        commit('setItems', questionnaires)
      }
    } catch (error) {
      //
    }
  },
  resetItems({ commit }) {
    commit('resetItems')
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
